export default __webpack_public_path__ + "static/media/chat_ketogo.d92800ee.svg";